import { useMemo } from 'react';
import { Frame, Container, Content, Header, Stack } from '@kinesis/bungle';
import { noop } from 'lodash/fp';
import { Layout } from '@/components/layout';
import { AccessControl as AccessControlEntry, Access, Identity } from '@/types';

import { AccessControlItem } from './access-control-item';
import { AccessControlInput } from './access-control-input';

const AccessControl = (props: AccessControlProps) => {
  const {
    isEditor,
    me,
    onRemove = noop,
    onChange = noop,
    candidates,
    onAuthorize = noop,
    access,
  } = props;
  const editorCount = useMemo(
    () => access.filter((v) => v.access !== 'viewer').length,
    [access],
  );

  return (
    <Content background='white' minHeight='100%'>
      <Container borderRadiusSize='large'>
        {isEditor && (
          <Header border>
            <Layout>
              <AccessControlInput
                access={access}
                candidates={candidates}
                onAuthorize={onAuthorize}
              />
            </Layout>
          </Header>
        )}
        <Frame>
          <Content padding='medium' paddingMode='equal'>
            <Layout>
              <Stack space='medium'>
                {access.map((a) => (
                  <AccessControlItem
                    key={`${a.identity.type}/${a.identity.id}`}
                    isEditor={isEditor}
                    isLastEditor={a.access === 'editor' && editorCount <= 1}
                    isMe={me === a.identity.id && a.identity.type === 'user'}
                    onRemove={onRemove}
                    onChange={onChange}
                    access={a}
                  />
                ))}
              </Stack>
            </Layout>
          </Content>
        </Frame>
      </Container>
    </Content>
  );
};

export type AccessControlProps = {
  isEditor: boolean;
  me: number;
  onRemove?: (i: Identity) => void;
  onChange?: (i: Identity, v: Access) => void;
  access: AccessControlEntry[];
  candidates: Identity[];
  onAuthorize?: (identity: Identity, access: Access) => void;
};

export { AccessControl };
